import { jsx as o, Fragment as d } from "react/jsx-runtime";
import l from "classnames";
import { createElement as u } from "react";
import '../../assets/LoadingSkeleton.css';const m = "_loader_14lhr_13", s = {
  "skeleton-group": "_skeleton-group_14lhr_7",
  loader: m
}, a = ({ children: t, className: e, as: r = "div" }) => u(r, { className: l(s["skeleton-group"], e) }, t), n = ({ className: t, width: e = "100%", height: r = "fit-content", aspectRatio: c, radius: i = "lg" }) => /* @__PURE__ */ o(
  "div",
  {
    className: l(s.loader, t),
    style: { width: e, height: r, aspectRatio: c || "auto", borderRadius: i !== "none" ? `var(--radius-${i})` : void 0 }
  }
), g = ({ className: t, widthHeight: e }) => /* @__PURE__ */ o(
  "div",
  {
    className: l(s.loader, t),
    style: { borderRadius: e / 2, height: e, width: e }
  }
), h = ({ className: t, isFullwidth: e }) => /* @__PURE__ */ o(n, { height: 48, radius: "full", width: e ? void 0 : 248, className: l(t) }), p = ({ lines: t = 1 }) => /* @__PURE__ */ o(d, { children: Array.from(Array(t).keys()).map((e) => /* @__PURE__ */ o(n, { height: 20, radius: "full" }, e)) }), k = () => /* @__PURE__ */ o(a.Rectangle, { height: 36, width: "75%", radius: "full" });
a.Rectangle = n;
a.Circle = g;
a.Button = h;
a.Paragraph = p;
a.Title = k;
export {
  a as default
};
